module.exports = __webpack_public_path__ + "img/no-data.b5e03c12.png";